import { render, staticRenderFns } from "./NavigationRoot.vue?vue&type=template&id=ccbb93d8"
import script from "./NavigationRoot.vue?vue&type=script&lang=js"
export * from "./NavigationRoot.vue?vue&type=script&lang=js"
import style0 from "./NavigationRoot.vue?vue&type=style&index=0&id=ccbb93d8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports